// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-73d2215a]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.good-modal .nav[data-v-73d2215a] {\n  margin-bottom: 15px;\n}\n.good-modal .box .good-img[data-v-73d2215a] {\n  width: 100px;\n}", ""]);
// Exports
module.exports = exports;
